import { InjectionToken } from '@angular/core';

export const CHAT_ASSET_BASE_URL = new InjectionToken<string>('CHAT_ASSET_BASE_URL', {
  factory: () => ''
});
